"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTouchEnabled = void 0;

var isTouchEnabled = function isTouchEnabled() {
  return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

exports.isTouchEnabled = isTouchEnabled;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/utils/mobile.js
// module id = 678
// module chunks = 0 15 16 17 18